export default __webpack_public_path__ + "static/media/3003.42214240.png";